import styled from '@emotion/styled'
import { Box } from '@mui/material'

const FullPageModal = styled.div`
	z-index: -1;
	position: fixed;
	background-color: #161616;
	width: 100%;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	border: 1px solid #393939;
	box-sizing: border-box;
	border-radius: 8px;
	padding: 40px;
	height: 100%;
	overflow: scroll;
`

const SectionWrapper = styled.div<{ column?: boolean }>`
	display: flex;
	align-items: center;
	flex-direction: ${props => (props.column ? 'column' : 'row')};
	margin: 1rem 2rem;
	justify-content: center;
	svg:hover {
		cursor: pointer;
	}
	a {
		margin-top: 20px;
	}
`
const BoxWrapper = styled.div`
	padding: 100px;
	width: '100%';
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 2rem;
	border: none;
	min-height: 530px;
	tbody {
		margin-top: 2rem;
		border-collapse: collapse;
		tr {
			border: 1px solid rgba(81, 81, 81, 1);
		}
		.MuiTableCell-sizeMedium {
			border: none;
		}
	}
	svg {
		font-size: 8rem;
		margin: 1rem;
	}
`
const LoaderWrapper = styled.div`
	padding: 20px;
	margin: 70px;
	.MuiTypography-subtitle2 {
		color: grey;
		font-weight: bold;
		strong {
			color: white;
		}
	}
`

const NoIssuesMessage = styled.div`
     padding:0.8rem;
	 border: 1px solid grey;
	 border-radius:5px;
	 text-align-center;

`
const ModalFooter = styled.div`
	position: sticky;
	right: 0;
	display: flex;
	align-items: center;
	margin: 2rem;
	bottom: 0;
	justify-content: right;
	button {
		margin-right: 10px;
	}
`

const FileUploadedBox = styled(Box)`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	${({ theme }) => `
        padding: ${theme.spacing(2)};
        background-color: ${theme.palette.info.light}`};
`

const FileUploadErrorBox = styled(Box)`
	display: flex;
	width: 100%;
	${({ theme }) => `
        padding: ${theme.spacing(2)};
        background-color: ${theme.palette.background.default}`}
`

export {
	BoxWrapper,
	FileUploadedBox,
	FileUploadErrorBox,
	FullPageModal,
	LoaderWrapper,
	ModalFooter,
	NoIssuesMessage,
	SectionWrapper,
}
